class FormGatedContent {
    constructor(slideElement) {
        this.slideElement = slideElement;
        this.$slideElement = jQuery(slideElement);
        this.$form = this.$slideElement.find('form');

        if (this.$form.length < 1) return; // Exit if no form is found

        this.init();

    }

    get gatedContentToken() {
        return this.$slideElement.data('form-gated-token') || '';
    }

    get thankYouPageUrl() {
        return this.$slideElement.data('form-thank-you-page') || '';
    }

    get gatedContentTitle() {
        return this.$slideElement.data('form-gated-content-title') || '';
    }

    init() {
        this.$form.find('input[name="form_gated_content"]').val(this.gatedContentToken);
        this.$form.find('input[name="form_gated_content_title"]').val(this.gatedContentTitle);

        this.$form.on('wpcf7mailsent', () => {
            const thankYouPageUrl = this.thankYouPageUrl;
            if (thankYouPageUrl) {
                window.location.href = thankYouPageUrl;
            }
        });
    }
}

jQuery(document).ready(function($) {
    const slides = jQuery('.syn-hero-container .slide');

    if (slides.length > 0) {
        slides.each(function() {
            const formGatedContent = new FormGatedContent(this);
        });
    }
});